import _defineProperty2 from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _Date$now from "@babel/runtime-corejs3/core-js-stable/date/now";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import { fastOptionsMerge } from './helper';
import { HttpEventTypes } from './common';
function defaultOnResponse(value) {
  return _Promise.resolve(value);
}
function defaultOnError(value) {
  return _Promise.reject(value);
}
function defaultOnException(error) {
  return _Promise.reject(error);
}
function defaultOnTrace() {}
function defaultOnFetch(url, options, fetchCall = fetch) {
  return fetchCall(url, options);
}
export let HttpTransport = function HttpTransport(handlers) {
  _classCallCheck(this, HttpTransport);
  _defineProperty(this, "onAuth", void 0);
  _defineProperty(this, "onResponse", void 0);
  _defineProperty(this, "onErrorResponse", void 0);
  _defineProperty(this, "onException", void 0);
  _defineProperty(this, "onTrace", void 0);
  _defineProperty(this, "onFetch", void 0);
  _defineProperty(this, "fetch", async (url, method, opts) => {
    const options = _objectSpread({}, opts, {
      method
    });
    const start = _Date$now();
    const fetchWithTrace = async () => {
      this.onTrace(HttpEventTypes.request, {
        url,
        options
      });
      let fetchOptions = options;
      if (this.onAuth) {
        const authOptions = await this.onAuth();
        fetchOptions = fastOptionsMerge(options, authOptions);
      }
      return fetch(url, fetchOptions);
    };
    try {
      const response = await this.onFetch(url, options, fetchWithTrace);
      if (response.ok) {
        this.onTrace(HttpEventTypes.response, {
          url,
          options,
          response,
          duration: _Date$now() - start
        });
        return this.onResponse(response);
      }
      this.onTrace(HttpEventTypes.error, {
        url,
        options,
        error: response,
        duration: _Date$now() - start
      });
      return this.onErrorResponse(response);
    } catch (exception) {
      this.onTrace(HttpEventTypes.exception, {
        url,
        options,
        exception: exception.toString(),
        duration: _Date$now() - start
      });
      return this.onException(exception);
    }
  });
  const _ref = handlers || {},
    onAuth = _ref.onAuth,
    onErrorResponse = _ref.onErrorResponse,
    onException = _ref.onException,
    onFetch = _ref.onFetch,
    onResponse = _ref.onResponse,
    onTrace = _ref.onTrace;
  this.onAuth = onAuth;
  this.onFetch = onFetch || defaultOnFetch;
  this.onResponse = onResponse || defaultOnResponse;
  this.onErrorResponse = onErrorResponse || defaultOnError;
  this.onException = onException || defaultOnException;
  this.onTrace = onTrace || defaultOnTrace;
};